/**
 * CBD Leaf Rain — Lightweight 3D falling cannabis leaves (realistic 7-leaflet shape)
 * Uses CSS animations only (no per-frame JS), GPU-accelerated via will-change + transform3d.
 */
(function () {
  var LF = 'M0,-38 C1,-35 2,-31 3,-27 L1.5,-25 C2.5,-22 3.5,-18 4,-14 L2.5,-12 C3.5,-8 4.5,-4 4.5,0 L3,2 C2,4 1,5 0,5.5 C-1,5 -2,4 -3,2 L-4.5,0 C-4.5,-4 -3.5,-8 -2.5,-12 L-4,-14 C-3.5,-18 -2.5,-22 -1.5,-25 L-3,-27 C-2,-31 -1,-35 0,-38Z';

  function makeLeafSVG(color) {
    return '<svg viewBox="0 0 100 130" fill="' + color + '" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M48.5,85 Q50,82 51.5,85 L51.5,122 Q50,126 48.5,122Z"/>' +
      '<path d="' + LF + '" transform="translate(50,82) scale(1.55,1.8)"/>' +
      '<path d="' + LF + '" transform="translate(50,80) rotate(-30) scale(1.25,1.45)"/>' +
      '<path d="' + LF + '" transform="translate(50,80) rotate(30) scale(1.25,1.45)"/>' +
      '<path d="' + LF + '" transform="translate(50,78) rotate(-55) scale(1,1.15)"/>' +
      '<path d="' + LF + '" transform="translate(50,78) rotate(55) scale(1,1.15)"/>' +
      '<path d="' + LF + '" transform="translate(50,76) rotate(-74) scale(0.65,0.75)"/>' +
      '<path d="' + LF + '" transform="translate(50,76) rotate(74) scale(0.65,0.75)"/>' +
      '</svg>';
  }

  document.querySelectorAll('.cbd-leaf-rain').forEach(function (container) {
    var count = parseInt(container.dataset.leafCount, 10) || 15;
    var minSize = parseInt(container.dataset.leafMinSize, 10) || 16;
    var maxSize = parseInt(container.dataset.leafMaxSize, 10) || 36;
    var minDuration = parseFloat(container.dataset.leafMinDuration) || 6;
    var maxDuration = parseFloat(container.dataset.leafMaxDuration) || 14;
    var color = container.dataset.leafColor || '#2d8a4e';
    var leafSVG = makeLeafSVG(color);
    var fragment = document.createDocumentFragment();

    for (var i = 0; i < count; i++) {
      var leaf = document.createElement('div');
      leaf.className = 'cbd-leaf-rain__leaf';

      var size = minSize + Math.random() * (maxSize - minSize);
      var startX = Math.random() * 100;
      var drift = (Math.random() - 0.5) * 80;
      var duration = minDuration + Math.random() * (maxDuration - minDuration);
      var delay = Math.random() * maxDuration;
      var spinDuration = 3 + Math.random() * 5;
      var startRot = Math.random() * 360;
      var z = -100 + Math.random() * 200;
      var opacity = 0.15 + Math.random() * 0.35;
      var blur = z < -50 ? 1 : z > 100 ? 1.5 : 0;

      leaf.style.cssText =
        'left:' + startX + '%;' +
        '--leaf-size:' + size + 'px;' +
        '--fall-duration:' + duration + 's;' +
        '--fall-delay:' + delay + 's;' +
        '--spin-duration:' + spinDuration + 's;' +
        '--start-x:0px;' +
        '--end-x:' + drift + 'px;' +
        '--start-rot:' + startRot + 'deg;' +
        '--leaf-z:' + z + 'px;' +
        '--leaf-opacity:' + opacity + ';' +
        '--leaf-blur:' + blur + 'px;';

      leaf.innerHTML = leafSVG;
      fragment.appendChild(leaf);
    }

    container.appendChild(fragment);
  });
})();
